import {
  CHANGE_PAGE,
  HOME_PAGE,
  ARTICLE_PAGE
} from "../constants/action-types";
import store from "../store";
import { doUpdateUrl } from "../actions";

const initialState = {
  currentPage: HOME_PAGE,
  articleId: null
};

window.addEventListener('popstate', () => {
  // here `doUpdateUrl` is an action creator that
  // takes the new url and stores it in Redux.
  store.dispatch(doUpdateUrl(window.location.pathname))
})

export default function routeReducer(state = initialState, action) {
  switch (action.type) {
    // changes the page we're looking at
    case CHANGE_PAGE:
      window.scrollTo({ top: 0 });
      switch (action.payload.url) {
        case ARTICLE_PAGE:
          window.history.pushState(
            null,
            "",
            `${action.payload.url}$${action.payload.id}`
          );
          return {
            ...state,
            currentPage: action.payload.url,
            articleId: action.payload.id
          };
        default:
          window.history.pushState(null, "", action.payload.url);
          return {
            ...state,
            currentPage: action.payload.url
          };
      }
    default:
      return state;
  }
}
